
import { useTranslation } from 'react-i18next';

export default function SocialProof() {
  const { t } = useTranslation();

  return (
    <section className="py-20 relative">
      <div className="max-w-[680px] mx-auto px-8 text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-[30%] h-[1px] bg-gradient-to-r from-transparent via-[#d4af37] to-transparent"></div>
        </div>

        <p className="text-2xl text-[#c5c5c5] leading-relaxed font-serif">
          {t('social.text')}
        </p>

        <div className="flex justify-center">
          <div className="w-[30%] h-[1px] bg-gradient-to-r from-transparent via-[#d4af37] to-transparent"></div>
        </div>
      </div>
    </section>
  );
}
